<template>
    <v-card class="model-data-wrapper" rounded="lg">
            <v-row v-for="(model, index) in loadedModels" :key="index">
                <v-col cols="12">
                        <v-card-title>Modell {{ index + 1 }}</v-card-title>
                        <v-card-text>
                            <div>Gesamtkunden: {{ model.totalCustomers }}</div>
                            <div>Gesamtkosten: {{ model.totalCost }}€</div>
                            <v-row v-for="(step, stepIndex) in model.steps" :key="stepIndex">
                                <v-col cols="12" md="3">Schritt: {{ step.start }} - {{ step.end }}</v-col>
                                <v-col cols="12" md="3">Preis pro Slot: {{ step.price }}€</v-col>
                                <v-col cols="12" md="3">Kunden: {{ step.customers }}</v-col>
                                <v-col cols="12" md="3">Gesamtkosten: {{ step.totalCost }}€</v-col>
                            </v-row>
                        </v-card-text>
                </v-col>
            </v-row>
    </v-card>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
    data() {
        return {
            models: []
        };
    },
    created() {
        this.loadModels();
    },
    computed: {
        ...mapState('marketing', ['loading', 'loadedModels'])
    },
    methods: {
        ...mapActions('marketing', ['getPriceModels']),
        async loadModels() {
            this.models = await this.$store.dispatch('marketing/getPriceModels');
        }
    }
};
</script>

<style scoped>
.model-data-wrapper {
    margin: 16px;
    padding: 24px;
}
</style>